export default __webpack_public_path__ + "static/media/world-atlas-3-rMIN.cad4cbf7.jpg";